export default __webpack_public_path__ + "static/images-world-map-left-b4a4405949b34d18c65d5223c7ae04d7.svg";